<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative pb-32 md:mb-0 ">
    <pagesubtitle subTitle="Choose your feedback link and brand your feedback survey with your logo and color."/>
    <vs-alert
    v-if="$store.state.dash.isMulti"
    class="p-4 my-3 rounded flex items-center text-dark"
      color="primary"
    ><feather-icon icon="InfoIcon" svgClasses="stroke-current text-light w-4 h-4" class="mx-1" />
      <span class="font-medium">Look and feel is shared between the following spaces:&nbsp;</span> {{this.$store.state.dash.multiLocations.map(a => a.businessName).join(", ") }}. Changes will be applied accross all spaces.
    </vs-alert>    
    <vx-card class="mb-base">
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2">
          <div class="relative">
          <label class="vs-input--label">Choose Feedback link</label>
          <vx-input-group class="" v-if="!($store.getters['dash/agency'].isAgency && !$store.getters['dash/agency'].isClientName)">
            <template slot="prepend">
              <div class="prepend-text text-dark pr-1" style="background: #FBEFFF;">                                
                <span v-if="$store.getters['dash/agency'].isAgency">
                  <span v-if="!$store.getters['dash/agency'].baseDomain">givefdbck.com/</span>  
                  <span v-else>{{$store.getters['dash/agency'].baseDomain}}/</span>  
                </span>
                <span v-else>feedback.link/</span>
              </div>
            </template>
            <vs-input :disabled="agencyFBLDisabled" name="feedback link" v-validate="'min:4|max:20'" v-model.trim="feedbackAddress" />
          </vx-input-group>
          <span class="block my-2 text-warning" v-if="errors.first('feedback link')">Your feedback link must be between 4 - 20 characters.</span>
          <div class="pt_topright">
            <span v-if="checkingFeedbackAddress" style="line-height: 2.3rem;">Checking...</span>
          </div>
          <div v-if="feedbackAddressValid === true" class="pt_topright">
            <vs-avatar class="w-6 h-6" color="success" icon-pack="feather" icon="icon-check" />
            <span class="text-success align-top" style="line-height: 2.3rem;">Available</span>
          </div>
          <div v-if="feedbackAddressValid === false" class="pt_topright">
            <vs-avatar class="w-6 h-6" color="danger" icon-pack="feather" icon="icon-x" />
            <span class="text-danger align-top" style="line-height: 2.3rem;">Taken</span>
          </div>
          <vs-collapse type="margin" :open-hover="true" class="small" >
            <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle">
              <div slot="header">
                What's this?
              </div>
              Choose a web address (link) your customers can visit to give feedback. Make sure it's short, easy to recall and identifiable with your business.  - e.g. If your business' name is Pat's Cupcakes, make your feedback link <span class="font-medium italic">feedback.link/pats</span>
            </vs-collapse-item>
          </vs-collapse>
          <vs-alert
          v-if="$store.getters['dash/agency'].isAgency && !$store.getters['dash/agency'].isClientName"
          class="p-4 my-3 rounded flex items-center text-dark"
          color="primary"
          >
          <p class="text-lg">
            <span class="font-semibold">Important:</span> Your (agency branded) client dashboard will be hosted at <span class="italic text-primary">{{ feedbackAddress }}.feedbackevaluate.com</span>. Changing this field is not possible, as it may break the login experience for clients due previous notification emails. Reach out to us if you'd like to know more.</p>
        </vs-alert>  
        
        <vs-alert v-if="$store.getters['dash/hasCustomDomainString'] && !$store.getters['dash/agency'].baseDomain" class="p-4 my-3 rounded flex items-center text-dark" color="primary">
          Your feedback link is also connected to <a :href="$store.getters['dash/feedbackURLTest']" target="_blank">{{ $store.getters['dash/hasCustomDomainString'] }}</a> 
        </vs-alert>

          </div>
          <div class="relative" >
          <label class="vs-input--label block mt-5" >Logo</label>
          <div v-if="logoUrl" class="w-full p-4">
            <img :src="logoUrl" class="h-10 mx-auto block"/>
          </div>
            <input type="file" style="display: none;" ref="logoInput" @change="filesChange($event.target.files)" accept="image/png, image/gif, image/jpeg">
            <div class="mb-2 optionalwrap">
              <vs-button  type="border" :color="logoUploaded? 'success':'primary'" @click.prevent="selectFile" class="w-full">{{ logoButtonText }}</vs-button>
              <p class="my-4" v-if="!logoUploaded">Select a good quality version of your business logo, preferably in PNG format and not larger than 600kb.</p>
              <span class="text-primary mt-2 block" v-if="logoMessage">{{ logoMessage }}</span>
                <div v-if="logoUploaded">
    <vx-tooltip class="mt-3" text="Some logos require a white border around it for some extra padding.">
          <vs-checkbox v-model="showWhiteLogoBorder">Show white border</vs-checkbox>
    </vx-tooltip>
    <vx-tooltip class="mt-3" text="If you have a transparent logo, disable this.">
          <vs-checkbox v-model="showWhiteLogoBackground">Enable white background</vs-checkbox>
    </vx-tooltip>
  </div>
              <!-- <vs-button disabled color="black" type="border" @click="$emit('back')" class="w-full">Uploading...</vs-button>
              <vs-button color="success" type="border" icon-pack="feather" icon="icon-check" class="w-full">Uploaded</vs-button>-->
            </div>
            <div class="pt_topright" v-if="logoLoading">
              <span class="text-primary mt-6 font-medium">Uploading...</span>
            </div>
          </div>
        </div>

      <div class="vx-col w-full md:w-1/2">
      <div class="flex flex-wrap mt-5 md:mt-0">
      <div class="w-full sm:w-1/2 sm:pr-3">
        <label class="vs-input--label">Primary color</label>
        <p class="text-sm sm:h-20 mb-5 sm:mb-0">Used for your survey background. Try to use your brand color here. </p>
        <chromepicker class="w-full" v-model="colorHex" :disableAlpha="true"/>
      </div>
      <div class="w-full sm:w-1/2 sm:pl-3 mt-6 sm:mt-0">
        <label class="vs-input--label">Secondary color</label>
        <p class="text-sm sm:h-20 mb-5 sm:mb-0">Used as a secondary color for buttons and decorations.</p>
        <chromepicker class="w-full" v-model="secondaryHex" :disableAlpha="true"/>
      </div>
      </div>
      </div>
      </div>
    </vx-card>

    <vx-card title="Feedback Link branding" class="mb-base">
      <p class="mb-4">Show a small "Powered by Feedback Link" note at the bottom of your feedback page and your review widgets.</p>
      <div class="flex items-center">
        <vs-switch v-model="brandingOn" :disabled="brandingLocked || brandingSaving" />
        <span class="ml-3 font-medium">{{ brandingOn ? 'Branding is shown' : 'Branding is hidden' }}</span>
        <span v-if="brandingSaving" class="ml-3 text-primary">Saving...</span>
      </div>
      <vs-alert
        v-if="brandingLocked"
        class="p-4 mt-4 rounded flex items-center text-dark"
        color="primary"
      ><feather-icon icon="LockIcon" svgClasses="stroke-current text-light w-4 h-4" class="mx-1" />
        <span>Removing the Feedback Link branding is included in every paid plan.&nbsp;<router-link to="/dash/settings/plan" class="font-medium">See plans</router-link></span>
      </vs-alert>
      <p v-else class="mt-4 text-sm">Changes to your review widgets can take a few minutes to show on your website.</p>
    </vx-card>

    <vx-card title="Survey Preview" style="overflow-x: scroll; min-height: 300px;" class="mb-base pt_mid"  >
      <div class="pt_absolute_center" style="z-index: 1;">
        <img class="w-10 spinner block mx-auto spinimg" src="@/assets/images/logo/smiley.png"/>
        <p class="mt-2 text-dark">Loading preview...</p>
      </div>
      <iframe name="previewframesettings" class="relative w-full block w-full max-w-md lg:max-w-2xl  xxl:max-w-2xl mx-auto h-124 lg:h-142 shadow-iframe border-none rounded" style="height: 700px; min-width: 330px; z-index: 10;"  />
    </vx-card>

    <vx-card  title="Email preview" class="pb-4 overflow-x-scroll">        
        <vs-collapse type="margin" :open-hover="true" class="small mb-10" >
                <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle" class="text-left p-4">
                  <div slot="header">
                    Can I change the rating metric on emails?
                  </div>
                  <span>The rating metric (CSAT/Star/NPS) shown on your invites is determined by the first rating question as set up in your survey. If you don’t have a rating question set up in your survey flow, it will default to Star rating.</span>
                </vs-collapse-item>
              </vs-collapse>
        <StarPreview :providedHex="colorHex" v-if="entityRatingType === 'star'"/>
        <CSATPreview :providedHex="colorHex" v-if="entityRatingType === 'csat'"/>
        <NPSPreview :providedHex="colorHex" v-if="entityRatingType === 'nps'"/>
      </vx-card>

    <savebutton submitText="Update" :accept="update" :goodToGo="formReady" />
  </div>
</template>


<script>


import NPSPreview from './emailpreviewcomponents/npspreview.vue'
import CSATPreview from './emailpreviewcomponents/csatpreview.vue'
import StarPreview from './emailpreviewcomponents/starpreview.vue'
import {
  Chrome
} from 'vue-color'
import debounce from 'debounce'
import { firebase } from '../firebase/firebaseConfig'
import Savebutton from './components/ptcomponents/Savebutton.vue'
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'
import planConfig from '../planConfig/planConfig.js'

const storageRef = firebase.storage().ref()

export default {
  data () {
    return {
      setupDataJSON: false,
      setupReceivedFBL: false,
      chosenLink: '',
      checkingFeedbackAddress: false,
      feedbackAddressValid: null,
      logoLoading: false,
      logoMessage: false,
      message: false,
      logoButtonText: 'Select Logo File',
      needHelpLogoColor: false,
      logoUploaded: false,
      //"Display Feedback Link branding" (2026-07 default-ON model): ON unless
      //the entity opted out. Saved instantly via its own endpoint (not the
      //page's Update button). brandingSuppressWatch guards programmatic sets.
      brandingOn: !(this.$store.state.dash.viewData.business.fblBrandingOff === true),
      brandingSaving: false,
      brandingSuppressWatch: false,
      showWhiteLogoBackground: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.showWhiteLogoBackground,
      showWhiteLogoBorder: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.showWhiteLogoBorder,
      feedbackAddress: this.$store.state.dash.viewData.business.publicFeedbackDetail.feedbackAddressHandle,
      secondaryHex: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.secondaryHex,
      colorHex: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.backgroundHex
    }
  },
  computed: {
    //free tier (and degraded/unknown plans) have branding locked ON — the
    //switch is disabled and an upgrade hint shows instead
    brandingLocked () {
      return planConfig.resolvePlan(this.$store.state.dash.viewData.business).limits.branding === true
    },
    agencyFBLDisabled () {
      if (!this.$store.getters['dash/agency'].isAgency) return false
      return this.$store.getters['dash/agency'].isClientName === false
    },
    entityRatingType() {
      return this.$store.state.dash.viewData.business.surveySetup.ratingType
    },
    logoUrl () {
      return this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.logoUrl
    },
    formReady () {
      if (this.errors.has('feedback link')) return false
      if (this.setupDataJSON === JSON.stringify({
        feedbackAddress: this.feedbackAddress,
        colorHex: this.colorHex,
        secondaryHex: this.secondaryHex,
        logoUrl: this.logoUrl,
        showWhiteLogoBackground: this.showWhiteLogoBackground,
        showWhiteLogoBorder: this.showWhiteLogoBorder
      })) return false
      if (this.feedbackAddress === '' || this.feedbackAddressValid === false || this.checkingFeedbackAddress) return false
      return true
    }
  },
  watch: {
    logoUrl() {
      this.updateIframe()
    },
    brandingOn (val) {
      if (this.brandingSuppressWatch) {
        this.brandingSuppressWatch = false
        return
      }
      this.saveBranding(val)
    },
    colorHex: {
      deep: true,
      handler(v) {
        this.updateIframe()
      }
    },
    secondaryHex: {
      deep: true,
      handler(v) {
        this.updateIframe()
      }
    },
    '$store.state.dash.viewData.business.publicFeedbackDetail.feedbackAddressHandle' (v) {
      //IF APPEARANCE INFO IS CHANGED BY THE BACKEND
      this.initSetupState()
      this.updateIframe()
    },
    showWhiteLogoBorder(){
      this.updateIframe()
    },
    showWhiteLogoBackground(){
      this.updateIframe()
    },
    '$store.state.dash.currentMultiLocationI' (v) {
      if (!this._inactive) {
        this.initSetupState()
        this.updateIframe()
      }
    },
    feedbackAddress(val) {

      //noconsoleconsole.log(val)

      this.feedbackAddress = val.replace(/[^a-zA-Z0-9]/g, "")

      this.feedbackAddress = this.feedbackAddress.toLowerCase()

        this.message = false
        if (val !== '') {
          if (val === this.setupReceivedFBL) {
            this.feedbackAddressValid = null
            return
          }

          if (val.length > 3) {
            this.feedbackAddressMessage = ''
            this.feedbackAddressValid = null
            this.checkingFeedbackAddress = true
            this.debounceFeedbackInput(val.replace(/[^a-zA-Z0-9]/g, ""))
          } else {
            this.feedbackAddressValid = null
          }
        } else {
          this.checkingFeedbackAddress = false
          this.feedbackAddressValid = null
          this.feedbackAddressMessage = ''
        }
    }
  },
  created () {
    this.initSetupState()
    this.updateIframe()
  },
  components: {
    Savebutton,
    Pagesubtitle,
    chromepicker: Chrome,
    NPSPreview,
    CSATPreview,
    StarPreview
  },
  methods: {
    saveBranding (showIt) {
      this.brandingSaving = true
      this.$store.dispatch('dash/UPDATE_BRANDING_SETTINGS', {
        brandingOff: !showIt
      }).then(() => {
        this.brandingSaving = false
        this.$vs.notify({
          title: 'Branding updated',
          text: showIt ? 'The Feedback Link branding will show on your feedback page and widgets.' : 'The Feedback Link branding is now hidden. Widgets on your website update within a few minutes.',
          color: 'success',
          time: 6500,
          iconPack: 'feather',
          icon: 'icon-check'
        })
      }).catch(() => {
        this.brandingSaving = false
        //revert the switch without re-saving
        this.brandingSuppressWatch = true
        this.brandingOn = !showIt
        this.$vs.notify({
          title: 'Branding',
          text: 'Oops! We couldn\'t save your branding preference. Please try again, and reach out for support if it happens again.',
          color: 'warning',
          time: 10000,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      })
    },
    updateIframe:  debounce( function () {
      
      //don't refresh if we're navigated away      
      if (this.$route.name !== 'settings-lookandfeel') return

      //post into iframe to get survey preview
      const form = document.createElement('form')
      form.method = 'post';
      if (process.env.NODE_ENV === 'development') {
        form.action = 'http://localhost:1088/mysurveypreview';
      } else {
        const isAgencyClient = this.$store.getters['dash/isAgencyClientCollaborator']
        form.action = `https://${isAgencyClient ? 'givefdbck.com' : 'feedback.link'}/mysurveypreview`;
      }
      form.target = 'previewframesettings'

      const postData = {
        isAgencyClient: this.$store.getters['dash/isAgencyClientCollaborator'],
        previewType: 'lookandfeel',
        appearanceInfo: {
            backgroundHex: this.colorHex,
            secondaryHex: this.secondaryHex,
            logoUrl: this.logoUrl,
            showWhiteLogoBackground: this.showWhiteLogoBackground,
            showWhiteLogoBorder: this.showWhiteLogoBorder
          },
        businessInfo: this.$store.state.dash.viewData.business.businessInfo,
        language: this.$store.getters['dash/currentLanguagePackName'].substring(0,2)
      }
       
      const hiddenField = document.createElement('input')
      hiddenField.type = 'hidden'
      hiddenField.name = 'json'
      hiddenField.value = JSON.stringify(postData)
      form.appendChild(hiddenField)

      //noconsoleconsole.log(postData)

      document.body.appendChild(form)
      
      form.submit()  
      
      setTimeout(() => {
        form.remove()
      }, 500)

    }, 1000),

    update () {
      //noconsoleconsole.log(this.formReady)
      if (this.formReady) {
        this.$vs.loading()
        this.$store.dispatch('dash/UPDATE_LOOK_AND_FEEL', {
          appearanceInfo: {
            backgroundHex: this.colorHex,
            secondaryHex: this.secondaryHex,
            logoUrl: this.logoUrl,
            showWhiteLogoBackground: this.showWhiteLogoBackground,
            showWhiteLogoBorder: this.showWhiteLogoBorder
          },
          feedbackAddressHandle: this.feedbackAddress
        }).then(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Updated look and feel',
            text: 'Look and feel updated successfully',
            color: 'success',
            time: 6500,
            iconPack: 'feather',
            icon:'icon-check'})
        }).catch(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Look and feel',
            text:'Oops! Something went wrong, and we couldn\'t update your look and feel settings. Please try again, and reach out for support if it happens again.',
            color: 'warning',
            time: 10000,
            iconPack: 'feather',
            icon:'icon-alert-circle'})
        })
      }
    },
    initSetupState () {

      //console.log('initting setup state')

      const bizBrandingOn = !(this.$store.state.dash.viewData.business.fblBrandingOff === true)
      if (this.brandingOn !== bizBrandingOn) {
        this.brandingSuppressWatch = true
        this.brandingOn = bizBrandingOn
      }

      this.feedbackAddress = this.$store.state.dash.viewData.business.publicFeedbackDetail.feedbackAddressHandle

      this.colorHex = this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.backgroundHex

      this.setupDataJSON = JSON.stringify({
        feedbackAddress: this.feedbackAddress,
        colorHex: this.colorHex,
        secondaryHex: this.secondaryHex,
        logoUrl: this.logoUrl,
        showWhiteLogoBackground: this.showWhiteLogoBackground,
        showWhiteLogoBorder: this.showWhiteLogoBorder
      })
      this.setupReceivedFBL = this.feedbackAddress

      if (this.logoUrl !== '' && this.logoUrl !== false) {
        this.logoUploaded = true
        this.logoButtonText = 'Change Logo'
      } else {
        this.logoUploaded = false
      }

    },
    next () {

      if (this.feedbackAddress === "") {
        this.message = "You need to choose your feedback link!"
        return
      }

      if (this.logoLoading) {
        this.message = "Your logo is still uploading."
        return
      }

      if (this.feedbackAddressValid === null) {
        this.message = "We're still checking if your chosen feedback link is valid."
        return
      }

      if (this.feedbackAddressValid === false) {
        this.message = "Your feedback link has already been taken - please choose another one."
        return
      }

      this.$emit('next')

    },
    selectFile() {
      this.$refs.logoInput.click()
    },
    filesChange(target) {
      
      // NEED TO CROSS BROWSER TEST/READ UP ON FILE API ON BROWSERS/SUPPORT
      //noconsoleconsole.log('checking image validity..')
      this.message = false
      this.logoMessage = false
      if (typeof target[0] !== 'undefined') {
        let validation = this.validateLogo(target[0])
        let imgName = this.$store.state.signUpState.recorded.businessInfo.businessName + (new Date().getTime() / 1000)
        imgName = (imgName.replace(/[`~±!@#$%^&*()_|+\-=÷¿?;:'",.<> \{\}\[\]\\\/]/gi, '')).toLowerCase()
        imgName = imgName.replace(/[^\w\s]/gi, '')
        //console.log(storageRef)
        if (validation.passed) {
          let imageRef = storageRef.child('businesslogos/' + imgName)
          this.logoLoading = true
          this.logoMessage = ''
          //noconsoleconsole.log('uploading image..')
          imageRef.put(target[0]).then((snapshot) => {
            //noconsoleconsole.log('umage uploaded')
            snapshot.ref.getDownloadURL().then((dURL) => {
              //noconsoleconsole.log(dURL)
              this.$store.commit('dash/MUTATE_APPEARANCE_INFO', {
                what: 'logoUrl',
                val: dURL
              })
              this.logoUploaded = true
              this.logoLoading = false
              this.message = false
              this.logoButtonText = target[0].name
            }).catch((e) => {
              //noconsoleconsole.log(e)
              this.logoLoading = false
              this.logoMessage = 'We couldn\'t upload your logo, please ensure it\'s not larger than 1MB and either a JPEG, GIF or PNG file.'
            })
          }).catch((e) => {
            //noconsoleconsole.log(e)
            this.logoMessage = 'We couldn\'t upload your logo, please ensure it\'s not larger than 1MB and either a JPEG, GIF or PNG file.'
            this.logoLoading = false
          })
        } else {
          this.logoMessage = validation.reason
        }
      }
    },
    validateLogo(file) {
      if (typeof file.size !== 'undefined') {
        if (file.size > 1000000) {
          return {
            passed: false,
            reason: 'Your logo file may not be larger than 1MB in size.'
          }
        }
      }
      if (typeof file.size !== 'undefined') {
        if ((file.type !== 'image/png') && (file.type !== 'image/jpeg') && (file.type !== 'image/gif')) {
          return {
            passed: false,
            reason: 'Your logo file needs to be a JPG, GIF or PNG file extension.'
          }
        }
      }
      return {
        passed: true,
        reason: ''
      }
    },
    checkFeedbackAddress(val) {
      this.checkingFeedbackAddress = true
      this.$store.dispatch('signUpState/checkAddressRegistered', {
        val: val
      }).then((res) => {
        //console.log('res')
        //console.log(res)
        this.message = false
        if (res.res === true) {
          //noconsoleconsole.log('true, context')
          if (res.context === this.feedbackAddress) {
            this.feedbackAddressValid = true
          } else {
            this.feedbackAddressValid = null
            this.message = false
          }
        } else {
          if (res.context === this.feedbackAddress) {
            this.feedbackAddressValid = false
          } else {
            this.feedbackAddressValid = null
            this.message = false
          }
          this.checkingFeedbackAddress = true
          this.feedbackAddressValid = false
        }
        this.checkingFeedbackAddress = false
      }).catch((e) => {
        //console.log(e)
        this.message = false
        this.checkingFeedbackAddress = false
      })
    },
    debounceFeedbackInput: debounce(function(val) {
      //console.log(val)
      if (val === this.setupReceivedFBL) return
      if (val.trim() !== '') {
        this.checkFeedbackAddress(val)
      }
    }, 700)
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}

.pt_mid {
  .vx-card__collapsible-content {
    min-height: 300px !important;
    position: relative !important;
  }
}


/*! rtl:end:ignore */
</style>
